export const capitalize = (str) => str.replace(/^([a-z])/, (first) => first.toUpperCase());
